<template>
  <v-app dark>
    <TheHeader v-if="loggedIn" />
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
      <TheFooter />
    </v-main>
    <TheToast />
    <TheConfirm />
    <TheModal />
    <TheMaintenance />
  </v-app>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';

  import TheHeader from './components/single/TheHeader';
  import TheFooter from './components/single/TheFooter';
  import TheToast from './components/single/TheToast';
  import TheConfirm from './components/single/TheConfirm';
  import TheModal from './components/single/TheModal';
  import TheMaintenance from './components/single/TheMaintenance';

  export default {
    name: 'App',
    components: {
      TheMaintenance,
      TheModal,
      TheToast,
      TheFooter,
      TheConfirm,
      TheHeader,
    },
    computed: {
      ...mapState('auth', ['loggedIn']),
      ...mapGetters('auth', ['expireAt']),
    },
    methods: {
      ...mapActions('user', ['fetchCurrentUser', 'fetchPermissions']),
      ...mapActions('confirm', ['clearConfirm']),
      ...mapActions('alert', ['hideToast']),
      ...mapActions('modal', ['hideModal']),
      ...mapActions('system', ['startHeartbeat']),
      init() {
        this.hideToast({});
        this.clearConfirm({});
        this.hideModal({});
      },
    },
    async created() {
      this.init();
      this.startHeartbeat();
      if (this.loggedIn) {
        await this.fetchCurrentUser({});
        await this.fetchPermissions({});
      }
    },
  };
</script>

<style lang="scss">
  @import './assets/styles/app';
  body {
    margin: 0px;
    font-family: $source-open-sans;
    font-weight: $normal;
    background: #F5F5FC;
    #app {
      background: #364150;
    }
    #footer {
      background: #364150;
      color: #7a8ca5;
    }
    a {
      color: #337ab7;
      text-decoration: none;
    }
  }
</style>
